export const WORKSPACE_SELECTED = 'Workspace selected';
